export enum ProcessingsPresetName {
  SETTINGS_PRESET = 'Settings Preset',
}
